import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { AuthService } from '@core/services';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  allowedEndPoints = ['profile-setup-steps', 'logout', 'lead-admin/my-permissions'];

  constructor(private readonly authService: AuthService) { }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // Skip adding token for external Dmart API calls (direct or via Angular proxy)
    if (request.url.includes('digital.dmart.in') || request.url.startsWith('/dmart-api')) {
      return next.handle(request);
    }

    // add auth header with jwt if user is logged in and request is to the api url
    const token = this.authService.token;

    if (token && this.authService.isLoggedIn) {
      if (this.authService.user?.isOnboarded || this.authService.user?.isAdmin || this.authService.user?.isLeadAdmin || this.includesAllowedEndpoint(request.url)) {
        if (request.url.includes('X-Amz-Signature')) {
          request = request.clone({
            setHeaders: {
              // No need to add Authorization header for signed URL requests
            }
          });
        } else {
          request = request.clone({ setHeaders: { 'Authorization': `Bearer ${token}` } });
        }
      } else {
        return of(); // cancel API if user role is not onboarded
      }
    }

    return next.handle(request);
  }

  includesAllowedEndpoint(requestURL) {
    return this.allowedEndPoints.findIndex((url: string) => requestURL.includes(url)) > -1;
  }
}
